import api from './_api';
import Vue from 'vue'


const postForm= async (context,payload) => {    
    let result=payload.payload
    let id=payload.id   
    result.entity_id = payload.parent_id
    
    try{        
        var response = await api.postForm(result,id)
        if (response) {                                         
            await context.dispatch('getAll');
            //alert(JSON.stringify(result))                    
            return response
        }
    }
    catch(error)  {              
        return Promise.reject(error);
    };    
};
        
const getAll = async (context) => {
    
    try {        
        var response = await api.fetchAll()                
        context.commit('PROJECT_SET_PROJECTS',response.data)         
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error);
    };    
};


const getById = async (context,payload) => {
    try {        
        var response = await api.getById(payload)                
        context.commit('PROJECT_SET_PROJECT',response.data)           
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error);
    };    
};

const deleteById = async (context,payload) => {
    
    try {              
        var response = await api.deleteById(payload.item_id)     
        await context.dispatch('getAll')           
        return response.data
    }
    catch(error) {   
        //alert(error)                          
        return Promise.reject(error);
    };    
};



export default {
  getAll,
  postForm,
  getById,
  deleteById,
  
};
